import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Tab } from '@mui/material';
import Async from 'components/Async';
import Page from 'components/Page';

import BooksTabs from '../constants/Tabs';
import useBooks from '../hooks/useBooks';
import BooksSection from './BooksSection';
import BooksNotFound from './notFound';
import BooksTabsComponent from './styled';

function BooksPage() {
	const { t } = useTranslation();
	const { tab, handleChangeTab, handleSearch, books } = useBooks();
	const groupedBooks = books.booksGroupedByPrograms();

	return (
		<Page
			searchProps={{
				onSearch: handleSearch,
				placeholder: t('resources.titleOrAuthor'),
			}}
			header={
				<BooksTabsComponent value={tab} onChange={handleChangeTab}>
					{BooksTabs.map((tab) => (
						<Tab label={tab.title} key={tab.book_type_id} />
					))}
				</BooksTabsComponent>
			}
			type="list"
		>
			<Async loading={books.loading}>
				{books.search ? (
					(books.booksWithProgress?.length > 0 && (
						<BooksSection groupedBooks={books.booksWithProgress} />
					)) || <BooksNotFound search={books.search} />
				) : (
					<BooksSection groupedBooks={groupedBooks} tab={tab} />
				)}
			</Async>
		</Page>
	);
}

export default observer(BooksPage);
